module.exports = __webpack_public_path__ + "img/contract.af5015e6.png";